export default function ContactHero() {
  return (
    <section className="relative pt-40 pb-20 bg-[#1a1a1a] overflow-hidden">
      <div className="absolute inset-0 z-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20commercial%20interior%20design%20studio%20reception%20desk%20elegant%20warm%20lighting%20stone%20wall%20dark%20atmosphere%20professional%20luxury%20space&width=1920&height=700&seq=contacthero001&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-px bg-[#b8956a]"></div>
              <span className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase">Contact Us</span>
            </div>
            <h1
              className="text-white font-bold leading-[1.25] mb-5"
              style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)' }}
            >
              聯絡諮詢
            </h1>
            <p
              className="text-white/65 leading-[1.75]"
              style={{ fontSize: '1.1875rem' }}
            >
              歡迎告訴我們你的商業空間需求，
              我們將在 24 小時內與你聯繫，提供初步建議與諮詢安排。
            </p>
          </div>
          {/* Quick Contact Badges */}
          <div className="flex flex-wrap gap-3">
            <a
              href="tel:0422023211"
              className="inline-flex items-center gap-2 px-5 py-3 bg-white/10 border border-white/20 text-white rounded-full text-sm font-medium hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-[#b8956a]"></i>
              04-2202-3211
            </a>
            <a
              href="mailto:newplusdesign2017@gmail.com"
              className="inline-flex items-center gap-2 px-5 py-3 bg-white/10 border border-white/20 text-white rounded-full text-sm font-medium hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line text-[#b8956a]"></i>
              Email 聯絡
            </a>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-5 py-3 bg-[#b8956a] text-white rounded-full text-sm font-medium hover:bg-[#a07d58] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-chat-1-line"></i>
              LINE 即時諮詢
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
